module.exports = __webpack_public_path__ + "static/media/CTLA_5-475w.e4d6bbf1.webp";